import { Routes } from "@angular/router";

import { AddCompanyPageComponent } from '../onboarding/components/add-company-page/add-company-page.component';
import { MultipleCompanyDashboardPageComponent } from '../onboarding/components/multiple-company-dashboard-page/multiple-company-dashboard-page.component';
import { SingleCompanyDashboardPageComponent } from '../onboarding/components/single-company-dashboard-page/single-company-dashboard-page.component';
import { AddUsersPageComponent } from '../onboarding/components/add-users-page/add-users-page.component';
import { CreateUserPageComponent } from '../onboarding/components/create-user-page/create-user-page.component';
import { ImportUserPageComponent } from '../onboarding/components/import-user-page/import-user-page.component';
import { DepartmentPageComponent } from '../onboarding/components/department-page/department-page.component';
import { AddDepartmentPageComponent } from '../onboarding/components/add-department-page/add-department-page.component';
import { ImportDepartmentPageComponent } from '../onboarding/components/import-department-page/import-department-page.component';
import { ImportPositionPageComponent } from '../onboarding/components/import-position-page/import-position-page.component';
import { BusinessInfoPageComponent } from '../onboarding/components/company-setup/business-info-page/business-info-page.component';
import { RemittanceInfoPageComponent } from '../onboarding/components/company-setup/remittance-info-page/remittance-info-page.component';
import { BankingInfoPageComponent } from '../onboarding/components/company-setup/banking-info-page/banking-info-page.component';
import { PayrollSchedulePageComponent } from '../onboarding/components/company-setup/payroll-schedule-page/payroll-schedule-page.component';
import { WcbPageComponent } from '../onboarding/components/company-setup/wcb-page/wcb-page.component';
import { EhtPageComponent } from '../onboarding/components/company-setup/eht-page/eht-page.component';
import { UploadDocumentsPageComponent } from '../onboarding/components/upload-documents-page/upload-documents-page.component';
import { TimeOffPoliciesPageComponent } from '../onboarding/components/time-off-policies-page/time-off-policies-page.component';
import { MultipleCompaniesPageComponent } from '../onboarding/components/multiple-companies-page/multiple-companies-page.component';
import { OnboardingPageComponent } from '../onboarding/components/onboarding-page/onboarding-page.component';
import { CompanyInfoPageComponent } from '../onboarding/components/company-info-page/company-info-page.component';
import { OnboardingSuccessPageComponent } from '../onboarding/components/onboarding-success-page/onboarding-success-page.component';
import { RegisterPageComponent } from '../onboarding/components/register-page/register-page.component';
import { SubmitPageComponent } from '../onboarding/components/submit-page/submit-page.component';
import { EmailVerifyPageComponent } from '../onboarding/components/email-verify-page/email-verify-page.component';

import { IsLoggedIn } from '../shared/guards/is-logged-in';

export const routes: Routes = [
  { path: "onboarding/companyinfo/:repeatSignUp", component: CompanyInfoPageComponent },
  { path: "onboarding/companyinfo", component: CompanyInfoPageComponent },
  { path: 'onboarding/verifyemail/:email', component: EmailVerifyPageComponent },
  {
    path: 'onboarding',
    component: OnboardingPageComponent,
    canActivate: [IsLoggedIn],
    children: [
      { path: "add/:orgId", component: AddCompanyPageComponent, canActivate: [false] },
      { path: "dashboard/multiple/:orgId", component: MultipleCompanyDashboardPageComponent },
      { path: "dashboard/single/:orgId", component: SingleCompanyDashboardPageComponent },
      { path: "user/add/:orgId", component: AddUsersPageComponent },
      { path: "user/add/:orgId/:errId", component: AddUsersPageComponent },
      { path: "user/create/:orgId", component: CreateUserPageComponent, canActivate: [false] },
      { path: "user/import/:orgId", component: ImportUserPageComponent, canActivate: [false] },
      { path: "department/:orgId", component: DepartmentPageComponent },
      { path: "department/:orgId/:errId", component: DepartmentPageComponent },
      { path: "department/add/:orgId", component: AddDepartmentPageComponent, canActivate: [false] },
      { path: "department/import/:orgId", component: ImportDepartmentPageComponent, canActivate: [false] },
      { path: "positions/import/:orgId", component: ImportPositionPageComponent, canActivate: [false] },
      { path: "businessinfo/:orgId", component: BusinessInfoPageComponent },
      { path: "remittanceinfo/:orgId", component: RemittanceInfoPageComponent },
      { path: "bankinginfo/:orgId", component: BankingInfoPageComponent },
      { path: "payrollschedule/:orgId", component: PayrollSchedulePageComponent },
      { path: "payrollschedule/:orgId/:errId", component: PayrollSchedulePageComponent },
      { path: "wcb/:orgId", component: WcbPageComponent, canActivate: [false] },
      { path: "eht/:orgId", component: EhtPageComponent, canActivate: [false] },
      { path: "eht/:orgId/:errId", component: EhtPageComponent, canActivate: [false] },
      { path: "upload/:orgId", component: UploadDocumentsPageComponent },
      { path: "upload/:orgId/:errId", component: UploadDocumentsPageComponent },
      { path: "timeoff/:orgId", component: TimeOffPoliciesPageComponent },
      { path: "companies", component: MultipleCompaniesPageComponent },
      { path: 'success/:orgId', component: OnboardingSuccessPageComponent },
      { path: 'submit/:orgId', component: SubmitPageComponent },
    ]
  },
  { path: "register", component: RegisterPageComponent }
];



// WEBPACK FOOTER //
// ./src/app/routes/onboarding.route.ts